import { supabase } from '@/lib/supabase';

export const topics = ['general', 'compliance', 'strategy', 'operations', 'reporting'] as const;
export interface WorkItem {
  id: string; vendor_id: string; title: string; assignee_id: string; due_at: string;
  status: string; work_state: string; topic: string; priority: string; series_id: string | null;
  remind_at: string | null; updated_at: string; crm_vendors: { display_name: string } | null;
}
export async function crmRpc(name: string, args: Record<string, unknown>) {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw new Error(error.message);
  return data;
}
export async function getWork(userId: string, filters: URLSearchParams, vendorId?: string) {
  const page = Math.max(0, Number(filters.get('page')) || 0);
  let query = supabase.from('crm_follow_ups').select('*,crm_vendors(display_name)', { count: 'exact' })
    .order('due_at').order('id').range(page * 50, page * 50 + 49);
  if (vendorId) query = query.eq('vendor_id', vendorId);
  else query = query.eq('assignee_id', userId);
  const view = filters.get('view') || 'open';
  query = query.eq('status', view === 'completed' ? 'completed' : view === 'cancelled' ? 'cancelled' : 'open');
  if (view === 'waiting') query = query.eq('work_state', 'waiting');
  if (view === 'recurring') query = query.not('series_id', 'is', null);
  if (view === 'overdue') query = query.lt('due_at', new Date().toISOString());
  if (filters.get('topic')) query = query.eq('topic', filters.get('topic'));
  if (filters.get('priority')) query = query.eq('priority', filters.get('priority'));
  const { data, error, count } = await query;
  if (error) throw new Error(error.message);
  return { items: (data ?? []) as WorkItem[], count: count ?? 0 };
}
